import { render } from "./EventCard.vue?vue&type=template&id=b67851e4&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=b67851e4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b67851e4"

export default script